export interface PurchaseInvoiceExtraReport {
  productKey: string;
  productDescription: string;
  quantity: number;
  price: number;
  value: number;
  notes: string;
  currencySymbol: string;
}
